<template>
  <div class="container">
    <div class="content">
      <div class="box">
        <div class="title">
          <span>{{jobInfo.Name}}</span>
          <div class="fragment">
            <!-- <div class="desc" v-html="jobInfo.RegistrationDesc"></div> -->
            <div class="desc">
              <span v-show="courseId == 2 || courseId == 4">证书有效期到期前三个月可以报名能力提升；</span>
              <span v-show="courseId == 1 || courseId == 3">同一学员最近一个月不可报名相同的培训。</span>
            </div>
          </div>
        </div>
        <div class="search-row">
          <el-input class="k-input" v-model.trim="queryModel.Name" placeholder="学员姓名" clearable></el-input>
          <el-input class="k-input" v-model.trim="queryModel.IdNumber" placeholder="身份证号" clearable></el-input>
          <el-button class="k-btn-primary xs" style="margin-top:10px" @click="onSearch">查询</el-button>
        </div>
        <div v-if="enterpriseEmployees.Items.length == 0" class="empty-row">
          <router-link style="color:#16cfd0" :to="{ name: 'qyglxygl'}">未查询到学员，点击此处添加学员</router-link>
        </div>
        <div v-else class="xy-row">
          <div v-for="(item, index) in enterpriseEmployees.Items" :key="index" :class="item.IsSelect ? 'xy-item selscted' : 'xy-item'" :style="item.IsDisabled ? 'opacity: 0.5;' : ''" @click="selectEmployee(item)">
            <div class="xy-tag">
            </div>
            <div class="xy-check-icon">
              <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="13" height="13">
                <path d="M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z" />
              </svg>
            </div>
            <div>
              <img class="xy-pic" :src="item.Pic + '?r='+Math.random()">
            </div>
            <div v-if="courseId == 2 || courseId == 4" class="xy-content">
              <div style="margin-bottom:6px;">{{item.Name}}
                <span v-show="item.CertCode" style="font-size: 14px;margin-left: 4px;">{{ item.CertCode }}</span>
                <span v-show="!item.CertCode" style="font-size: 14px;margin-left: 4px;">无证书</span>
              </div>
              <div>{{item.IdNumber}}</div>
              <div v-show="item.CertCode" style="font-size: 14px; cursor: pointer; color: #16cfd0;">证书有效期至：{{ item.CertExpirDate | dateformat('YYYY-MM-DD') }}</div>
            </div>
            <div v-else class="xy-content">
              <div style="margin-bottom:11px;">{{item.Name}}<span>{{item.Sex==0?'男':'女'}}</span><span>{{Math.trunc(item.Age)}}岁</span><span :title="item.EmployeeDegree" style="width:32px;white-space:nowrap;overflow:hidden; display: inline-flex;">{{item.EmployeeDegree}}</span></div>
              <div>{{item.IdNumber}}</div>
            </div>
          </div>
        </div>
        <div>
          <el-pagination :page-size="queryModel.PageSize" layout="total, prev, pager, next" :total="enterpriseEmployees.TotalRecords" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="footer">
      <el-button class="k-btn-primary lg" @click="onSubmit">确定</el-button>
      <el-button class="k-btn-default lg" @click="onCancel">取消</el-button>
    </div>
  </div>
</template>
<script>
import { mapGetters, ProjectSettings } from '@/views/base/base.js'
import moment from 'moment';
export default {
  data() {
    return {
      courseId: null,
      jobId: null,
      queryModel: {
        Page: 1,
        PageSize: 12,
        CourseId: null,
        JobId: null,
        Name: null,
        IdNumber: null,
        EmployeeDegreeId: null,
        EmployeeTitleId: null,
        ExcludeEmployeeIds: null,
        RegBeginDate: null,
        RegEndDate: null
      },
      employees: [],
      oldEmployees: [],
      enterpriseEmployees: {
        Items: [],
        TotalRecords: 0
      },
      registLearnSettings: {},
      allCourseJobs: []
    };
  },
  computed: {
    jobInfo: function () {
      let that = this;
      let obj = _.cloneDeep(this.$store.getters.getCommonJob);
      obj.JobId = that.$route.query.Id;
      return obj;
    },
    ...mapGetters({
      employeeTitles: 'getEmployeeTitle',
      employeeDegree: 'getEmployeeDegree',
      courseDetails: 'getCourseDetails'
    })
  },

  filters: {
    dateformat(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
      if (dataStr === null) {
        return '';
      }
      return moment(dataStr).format(pattern)
    }
  },
  mounted() {
    let that = this;
    this.courseId = Number(this.$route.query.courseId);
    this.jobId = Number(this.$route.query.jobId);
    this.$store.dispatch('getCommonJob', { jobId: this.jobId }).then(res => {
      document.title = '选择学员 - ' + res.Data.Name + ' - 培训报名 - ' + ProjectSettings.Title;
    });
    this.$store.dispatch('getCourseOpenJobs', { courseId: this.courseId }).then(res => {
      that.allCourseJobs = res.Data;
    });

    this.$store.dispatch('getCourseDetails', { Id: this.courseId }).then(res => {
      // 处理验证配置
      let registLearnSettings = _.filter(ProjectSettings.RegistLearnSettings, (item) => {
        if (item.CourseId === that.courseId && (item.JobIds.length === 0 || item.JobIds.indexOf(that.jobId) !== -1)) {
          return true;
        }
      });

      if (registLearnSettings.length > 0) {
        that.registLearnSettings = registLearnSettings[0];
      }

      // 获得已选学员
      if (that.$route.params.employees) {
        that.employees = that.$route.params.employees;
        that.oldEmployees = _.cloneDeep(that.$route.params.employees);
      }

      // 查询学员
      that.queryModel = {
        Page: 1,
        PageSize: 12,
        CourseId: that.courseId,
        JobId: that.jobId,
        Name: null,
        IdNumber: null,
        EmployeeDegreeId: null,
        EmployeeTitleId: null,
        ExcludeEmployeeIds: null
      }
      if (that.employees && that.employees.length > 0) {
        that.queryModel.ExcludeEmployeeIds = _.map(that.employees, 'EmployeeId').toString();
      }
      that.loadEnterpriseEmployee();
    });
  },
  methods: {
    onSubmit() {
      let that = this;

      this.$router.push({
        name: 'courseEnrollStudent',
        query: {
          courseId: this.courseId,
          jobId: this.jobId,
          learnId: this.$route.query.learnId
        },
        params: {
          employees: that.employees
        }
      });
    },
    onCancel() {
      this.$router.push({
        name: 'courseEnrollStudent',
        query: {
          courseId: this.courseId,
          jobId: this.jobId,
          learnId: this.$route.query.learnId
        },
        params: {
          employees: this.oldEmployees
        }
      });
    },
    handleCurrentChange(val) {
      this.queryModel.Page = val;
      this.loadEnterpriseEmployee();
    },
    loadEnterpriseEmployee() {
      let that = this;
      if (this.registLearnSettings.RegBeginDate) {
        this.queryModel.RegBeginDate = this.registLearnSettings.RegBeginDate;
      }
      if (this.registLearnSettings.RegEndDate) {
        this.queryModel.RegEndDate = this.registLearnSettings.RegEndDate;
      }
      this.$store.dispatch('getLearnAddEmployees', this.queryModel).then(res => {
        let data = res.Data;
        _.forEach(data.Items, row => {
          // 初始化数值
          row.Age = that.getEmployeeAge(row.IdNumber);
          row.IsSelect = false;
          row.IsDisabled = false;

          // 如果不在白名单内
          if (that.courseDetails.IsEnableWhiteList === 1 && row.IsWhiteList === 0) {
            row.IsDisabled = true;
          }

          // 能力提升需要证书，并且超期日期在6个月之内
          if (that.courseId === 2 || that.courseId === 4) {
            if (!row.CertCode) {
              row.IsDisabled = true
            } else {
              let now = moment().startOf('day');
              let nowUnix = now.unix();
              let expirUnix = moment(row.CertExpirDate).startOf('day').unix();
              let maxUnix = moment().add(3, 'M').startOf('day').unix();

              if (expirUnix < nowUnix || expirUnix > maxUnix) {
                row.IsDisabled = true
              }
            }
          }

          // 检测人员报名超过3次 或 岗位已报过名
          if (that.courseId === 5) {
            if (row.CourseBMCount > 2 || row.JobBMCount > 0) {
              row.IsDisabled = true
            }
          }

          // 判断是否已被选中
          if (that.employees.length > 0) {
            let emp = _.find(that.employees, function (e) { return e.EmployeeId === row.Id; });
            if (emp != null) {
              row.IsSelect = true;
            }
          }
        });
        this.enterpriseEmployees = data;
      });
    },
    selectEmployee(row) {
      let that = this;
      let item = _.find(this.enterpriseEmployees.Items, function (e) { return e.Id === row.Id; });

      if (item.IsSelect) {
        // 去除取消选中的人员
        that.employees = _.filter(that.employees, function (e) {
          return e.EmployeeId !== row.Id;
        });
        item.IsSelect = false;
        this.$forceUpdate();
        return;
      }

      // 验证是否在白名单内
      if (that.courseDetails.IsEnableWhiteList === 1 && row.IsWhiteList === 0) {
        this.$alert(that.courseDetails.WhiteListErrorMsg, '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

      // 验证是否可以报名能力提升
      if ((that.courseId === 2 || that.courseId === 4) && !row.CertCode) {
        this.$alert('合格证书不存在，不能进行报名', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

      let now = moment().startOf('day');
      let nowUnix = now.unix();
      let expirUnix = moment(row.CertExpirDate).startOf('day').unix();
      let maxUnix = moment().add(3, 'M').startOf('day').unix();

      // 验证是否可以报名能力提升
      if ((that.courseId === 2 || that.courseId === 4) && (expirUnix < nowUnix || expirUnix > maxUnix)) {
        this.$alert('证书有效期到期前三个月报名', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

      // 验证是否有正在审核的补考报名
      if (row.ApproveMakeUpCount > 0) {
        this.$alert('补考报名未开通的情况下，同一个人不允许重复进行报名。', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

      if (that.registLearnSettings.BmMonthVisible && (that.courseId === 1 || that.courseId === 3)) {
        // 验证同个培训一个月内同一人不能报名多个专业
        if (row.CourseBMCount > 0) {
          this.$alert('该学员已报名相同培训。', '提示', {
            confirmButtonText: '确定'
          });
          return;
        }

        let isDiff = false;
        let enrollStudent = this.$store.getters.getEnrollStudent;
        // console.log('enrollStudent', enrollStudent);
        // console.log('row', row);

        if (enrollStudent && enrollStudent.length > 0) {
          _.forEach(enrollStudent, tmp => {
            _.forEach(tmp.Employees, tmp1 => {
              if (tmp1.EmployeeId === row.Id && tmp.JobId !== that.jobId) {
                // console.log('tmp.JobId', tmp.JobId);
                // console.log('that.jobId', that.jobId);
                isDiff = true;
              }
            })
          })
        }

        if (isDiff) {
          that.$alert('该学员已报名相同培训。', '提示', {
            confirmButtonText: '确定'
          });
          return;
        }
      }

      if (that.courseId === 5) {
        // 验证同个培训一个月内同一人不能报名多个专业
        if (row.CourseBMCount > 2) {
          this.$alert('每批次报名每人最多允许报名 3 个岗位。', '提示', {
            confirmButtonText: '确定'
          });
          return;
        }
        // 验证同个培训一个月内同一人不能报名多个专业
        if (row.JobBMCount > 0) {
          this.$alert('同一报名批次内已报名相同岗位', '提示', {
            confirmButtonText: '确定'
          });
          return;
        }
      }

      // 验证学员年龄、学历
      if (that.registLearnSettings.AgeVisible) {
        // 年龄验证
        let ageVisible = that.registLearnSettings.AgeVisible;
        let minAge = 18;
        let maxAge = 100;

        if (row.Sex === 0) {
          minAge = ageVisible.Male.Min;
          maxAge = ageVisible.Male.Max;
        } else {
          minAge = ageVisible.Female.Min;
          maxAge = ageVisible.Female.Max;
        }

        if (row.Age < minAge) {
          this.$alert('年龄不得小于' + minAge + '岁。', '提示', {
            confirmButtonText: '确定'
          });
          return;
        }
        if (row.Age > maxAge) {
          this.$alert('年龄不得大于' + maxAge + '岁。', '提示', {
            confirmButtonText: '确定'
          });
          return;
        }

        // 技术工人 年龄验证
        if (that.jobInfo.JobClassId && ageVisible.JobLevelId) {
          let settings = ageVisible.JobLevelId;

          settings = _.filter(settings, (t) => {
            return t.Id === that.jobInfo.JobClassId;
          });

          if (settings.length > 0) {
            let minAge = settings[0].Min;
            if (row.Age < minAge) {
              this.$alert('年龄不得小于' + minAge + '岁。', '提示', {
                confirmButtonText: '确定'
              });
              return;
            }
          }
        }
      }

      // 学历验证 放到后面去了
      // if (that.registLearnSettings.DegreeVisible && !row.EmployeeDegreeId) {
      //   this.$alert('学历不能为空。', '提示', {
      //     confirmButtonText: '确定'
      //   });
      //   return;
      // }

      // 验证报名金额是否超过2万元
      let currentJobPrice = that.jobInfo.Price;
      let currentJobSubTotal = currentJobPrice * (that.employees.length + 1);

      let otherJobsSubTotal = 0;
      let enrollStudent = this.$store.getters.getEnrollStudent;
      if (enrollStudent && enrollStudent.length > 0) {
        _.forEach(enrollStudent, tmp => {
          if (Number(tmp.JobId) !== that.jobId) {
            let job = _.find(that.allCourseJobs, { Id: Number(tmp.JobId) });
            if (job) {
              otherJobsSubTotal += job.Price * tmp.Employees.length;
            }
          }
        });
      }

      let totalPrice = currentJobSubTotal + otherJobsSubTotal;

      if (totalPrice >= 20000) {
        this.$alert('单笔订单金额限制  20000 元以下', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

      // 添加人员到数据
      let employee = _.cloneDeep(item);

      employee.EmployeeId = employee.Id;
      employee.PicXlzs = that.registLearnSettings.XlzsVisible ? employee.PicXlzs : null;
      employee.PicZcjzszs = that.registLearnSettings.ZcjzszsVisible ? employee.PicZcjzszs : null;
      employee.PicSfzzm = that.registLearnSettings.SfzzmVisible ? employee.PicSfzzm : null;
      employee.PicSfzfm = that.registLearnSettings.SfzfmVisible ? employee.PicSfzfm : null;
      employee.PicZyzs = that.registLearnSettings.ZyzsVisible ? employee.PicZyzs : null;
      employee.PicZp = null;
      // 如果学员头像为480 * 600
      if (that.registLearnSettings.ZpVisible && employee.Pic) {
        let image = new Image();
        image.src = employee.Pic;
        image.onload = function () {
          let width = image.width;
          let height = image.height;
          if (width === 480 && height === 600) {
            employee.PicZp = employee.Pic;
          }
        };
      }
      employee.PicTjb = null;
      employee.PicCns = null;
      employee.CertificateCode = null;
      employee.CertificateDate = null;
      employee.PicGzzm = null;
      employee.PicBmb = null;
      employee.PicSmpz = null;
      employee.PicHgz = null;
      employee.PicAkz = null;
      employee.PicCzz = null;
      employee.PicSqb = null;
      employee.PicJcyzs = null;
      employee.FilePsb = null;
      employee.WorkYear = null;
      employee.NativePlace = null;
      employee.Major = null;
      employee.ZyzsType = null;
      employee.IsUploadPicXlzs = false;
      employee.IsUploadPicZcjzszs = false;
      employee.IsUploadPicSfzzm = false;
      employee.IsUploadPicSfzfm = false;
      employee.IsUploadPicZyzs = false;
      that.employees.push(employee);

      // 选中
      item.IsSelect = true;
      this.$forceUpdate();
    },
    onSearch() {
      this.queryModel.Page = 1;
      this.loadEnterpriseEmployee();
    },
    getEmployeeAge(idNumber) {
      let myDate = new Date();
      let month = myDate.getMonth() + 1;
      let day = myDate.getDate();
      let age = myDate.getFullYear() - idNumber.substring(6, 10) - 1;
      let iMonth = Number(idNumber.substring(10, 12));
      let iday = Number(idNumber.substring(12, 14));
      let diffMonth = 0;
      if (iMonth < month || (iMonth === month && iday <= day)) {
        age = age + 1;
      }
      if (iMonth < month) { // 当年已经过生日
        diffMonth = month - iMonth;
      } else if (iMonth > month) { // 当年生日还没过
        diffMonth = 12 - (iMonth - month);
      }
      let rate = Math.floor((diffMonth / 12) * 100) / 100;
      age = age + Number(rate);
      // console.log('idNumber', idNumber);
      // console.log('iMonth', iMonth);
      // console.log('month', month);
      // console.log('rate', rate);
      // console.log('diffMonth', diffMonth);
      // console.log('age3', age);
      return age;
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  .content {
    .box {
      .title {
        font-size: 30px;
        color: #333333;
        margin-top: 80px;
        margin-bottom: 32px;
        display: flex;
        flex-direction: column;
        .fragment {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          .desc {
            color: #ff6715;
            font-size: 14px;
            margin-top: 20px;
          }
        }
      }
      .search-row {
        display: flex;
        justify-content: flex-end;
        .el-input {
          width: 184px;
          margin-right: 24px;
        }
      }
      .empty-row {
        height: 80px;
        line-height: 80px;
        text-align: center;
      }
      .xy-row {
        margin-top: 32px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        .xy-item {
          position: relative;
          width: 274px;
          height: 96px;
          margin-right: 24px;
          margin-bottom: 32px;
          line-height: 21px;
          background: #ffffff;
          border: 1px solid #dcdcdc;
          -webkit-transition: 0.3s all ease-in-out;
          transition: 0.3s all ease-in-out;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          overflow: hidden;
          cursor: pointer;
          .xy-pic {
            width: 48px;
            height: 60px;
            margin-left: 16px;
            margin-right: 16px;
          }
          .xy-content {
            span {
              margin-left: 10px;
            }
          }
          .xy-tag {
            position: absolute;
            right: -25px;
            top: -25px;
            width: 50px;
            height: 50px;
            text-align: center;
            background-color: #a8a8a8;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            -webkit-box-shadow: 0 1px 1px #ccc;
            box-shadow: 0 1px 1px #ccc;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
            -webkit-box-pack: end;
            -ms-flex-pack: end;
            justify-content: flex-end;
          }
          .xy-check-icon {
            position: absolute;
            top: 1px;
            right: 4px;
          }
        }
        .xy-item:nth-child(4) {
          margin-right: 0px;
        }
        .xy-item:nth-child(8) {
          margin-right: 0px;
        }
        .xy-item:nth-child(12) {
          margin-right: 0px;
        }
        .selscted {
          border: 1px solid #16cfd0;
          .xy-tag {
            background-color: #16cfd0;
          }
        }
        .xy-item:hover {
          box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.16);
        }
      }
      .el-pagination {
        text-align: center;
      }
    }
  }
  .footer {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
<style scoped>
.desc >>> a {
  color: #16cfd0 !important;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/course_enroll_add_student.vue